import React, { useState, useEffect } from 'react';
import './LogComponent.scss';
import Broadcast from '../../../store/externalCalls/broadcast';
import LogElement from './LogElement';
import Button, {ButtonTheme } from '../../atoms/button/button';

let stopSocketMessages=false;
let storeSocketMessages=[];

const LogRealTime = ({dataId,channel,filters,onSocket}) => {

    const [logs,setLogs]=useState([]);
    const [logsFiltered,setLogsFiltered]=useState([]);
    const [websocketChannel]=useState(channel+dataId);
    const [websocketItems]=useState(["newLog"]);
    const [websocketSessionParams]=useState(['liveId']);
    const [filtered, setFiltered] = useState(false);
    const [maxRealTimeLogs]=useState(1000);

    useEffect(()=>{
        //console.log("INIT LOG REAL");
        setLogs([]);
       
    },[]);
    useEffect(()=>{
      if(filters!=null){
        filterValues(filters,logs);
      }
      
    },[filters]);

    const filterValues=(filters,logs)=>{
        let filtered=null;
        if(filters){
          if(filters.filterChecks){
            Object.keys(filters.filterChecks).forEach((e)=>{
              if(filters.filterChecks[e]){
                let myFilter=logs.filter(el=>el.type.toLowerCase()===e);
                if(filtered==null)
                  filtered=[...myFilter];
                else  
                  filtered=[...filtered,...myFilter];
              }
            });
          }
          if(filters.filterText){
            if(filtered==null){
              filtered=logs;
            }
            filtered = filtered.filter(el =>JSON.stringify(el).includes(filters.filterText));
          }
          if(filtered==null){
            filtered=logs;  
          }
          setLogsFiltered(filtered);
        }else{
          setLogsFiltered(logs);
        }
    }

    const onBroadcastingReceived = (e) => {
      // console.log("broadcasting 2",e);
      if(e.message){
        if(stopSocketMessages){
          storeSocketMessages.push(e.message);
        }else{
          storeSocketMessages=[];
          runSocketMessages(e.message);
        }
      }
      onSocket(true);
    };

    const runSocketMessages=(msgs)=>{
      msgs.forEach((msg)=>{
        for(let item in websocketItems){
          setLogs((prevLogs) => {
            let updatedLogs = [msg, ...prevLogs]; 
            if(updatedLogs.length>maxRealTimeLogs){
              updatedLogs=updatedLogs.slice(0,maxRealTimeLogs);
            }
            console.log(updatedLogs);
            filterValues(filters, updatedLogs); 
            return updatedLogs;
          });
          console.log("msg",msg);
        }
      });
    }
    const hangleClearScreenLogs=()=>{
      setLogs([]);
      setLogsFiltered([]);
    }

    return (
        <div className="content">
             <Broadcast
                eventChanel={websocketChannel}
                sessionParams={websocketSessionParams}
                onEventReceived={(e) => { onBroadcastingReceived(e); }}
            />
            {logsFiltered && logsFiltered.length>0 && <div className="log-button-center">
              <Button
                  id={`refresh`}
                  type={'button'}
                  onClick={() => hangleClearScreenLogs()}
                  theme={ButtonTheme.PRIMARY}
                >
                  clear screen logs
              </Button>
            </div>
            }
            {<div className='filter-main'>
                <div className='filterinfo'>{logsFiltered && logsFiltered.length} {filtered?"filtered":"showed"} of {(logsFiltered.length)} {(filtered?"filtered logs":"total logs (max of "+maxRealTimeLogs+" real time logs)")}</div>
                {logs && logsFiltered.length==0 && <div className="logComponent-log">------- waiting websockets --------</div>}
            </div>}
        
            <div className="logComponent-log">
              {logsFiltered && logsFiltered.length>0 && logsFiltered.map((el,index)=>{
                // console.log("element",el);
                return(
                  <div key={index}>
                    <LogElement data={el}/>
                  </div>
                );
              })}
            </div>
        </div>
    );
}

export default LogRealTime;
